import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "11",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M9.271 10.992c.396 0 .724-.145 1.032-.454l7.266-7.43c.25-.25.367-.55.367-.906 0-.724-.57-1.312-1.293-1.312-.357 0-.686.154-.946.415l-6.416 6.6-6.436-6.6C2.585 1.045 2.266.89 1.9.89 1.176.89.597 1.478.597 2.202c0 .357.126.656.377.907l7.265 7.43c.309.318.637.453 1.032.453"
    }, null, -1)
  ])))
}
export default { render: render }